module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/DisabledArrow.f679eb39.svg";